<svg class="initials-wrapper" viewBox="0 0 40 40">
  <foreignObject height="40" width="40">
    <div class="initials">
      {{ placeholder() }}
    </div>
  </foreignObject>
</svg>

@if (image()) {
  <img
    class="image"
    [src]="image()"
    [alt]="placeholder() + ' avatar image'"
  />
}
